"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const S = (0, tslib_1.__importStar)(require("./styles"));
const Title = ({ children, as = 'h1' }) => children ? (0, jsx_runtime_1.jsx)(S.StyledTitle, Object.assign({ as: as }, { children: children }), void 0) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
exports.default = Title;
